import React from "react";

import { Row } from '@shadcn/components/ui/row';
import { Col } from '@shadcn/components/ui/col';
import { CardContent, Card } from "@shadcn/components/ui/card";
import { Label } from "@shadcn/components/ui/label";

import WelcomeComp from "./WelcomeComp";
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import { arrayNotNull } from "../../../utilities/utilities";
import useQuery from '../../../helpers/JIFI/useQuery';

import { Link } from "react-router-dom";

import './skelton.css';

const countryLookup = {
  "Andorra": "🇦🇩",
  "United Arab Emirates": "🇦🇪",
  "Afghanistan": "🇦🇫",
  "Antigua And Barbuda": "🇦🇬",
  "Anguilla": "🇦🇮",
  "Albania": "🇦🇱",
  "Armenia": "🇦🇲",
  "Angola": "🇦🇴",
  "Antarctica": "🇦🇶",
  "Argentina": "🇦🇷",
  "American Samoa": "🇦🇸",
  "Austria": "🇦🇹",
  "Australia": "🇦🇺",
  "Aruba": "🇦🇼",
  "Aland Islands": "🇦🇽",
  "Azerbaijan": "🇦🇿",
  "Bosnia And Herzegovina": "🇧🇦",
  "Barbados": "🇧🇧",
  "Bangladesh": "🇧🇩",
  "Belgium": "🇧🇪",
  "Burkina Faso": "🇧🇫",
  "Bulgaria": "🇧🇬",
  "Bahrain": "🇧🇭",
  "Burundi": "🇧🇮",
  "Benin": "🇧🇯",
  "Saint Barthelemy": "🇧🇱",
  "Bermuda": "🇧🇲",
  "Brunei Darussalam": "🇧🇳",
  "Bolivia": "🇧🇴",
  "BQ": "🇧🇶",
  "Brazil": "🇧🇷",
  "Bahamas": "🇧🇸",
  "Bhutan": "🇧🇹",
  "Bouvet Island": "🇧🇻",
  "Botswana": "🇧🇼",
  "Belarus": "🇧🇾",
  "Belize": "🇧🇿",
  "Canada": "🇨🇦",
  "Cocos (Keeling) Islands": "🇨🇨",
  "Congo, Democratic Republic": "🇨🇩",
  "Central African Republic": "🇨🇫",
  "Congo": "🇨🇬",
  "Switzerland": "🇨🇭",
  "Cote D'Ivoire": "🇨🇮",
  "Cook Islands": "🇨🇰",
  "Chile": "🇨🇱",
  "Cameroon": "🇨🇲",
  "China": "🇨🇳",
  "Colombia": "🇨🇴",
  "Costa Rica": "🇨🇷",
  "Cuba": "🇨🇺",
  "Cape Verde": "🇨🇻",
  "CW": "🇨🇼",
  "Christmas Island": "🇨🇽",
  "Cyprus": "🇨🇾",
  "Czech Republic": "🇨🇿",
  "Germany": "🇩🇪",
  "Djibouti": "🇩🇯",
  "Denmark": "🇩🇰",
  "Dominica": "🇩🇲",
  "Dominican Republic": "🇩🇴",
  "Algeria": "🇩🇿",
  "Ecuador": "🇪🇨",
  "Estonia": "🇪🇪",
  "Egypt": "🇪🇬",
  "Western Sahara": "🇪🇭",
  "Eritrea": "🇪🇷",
  "Spain": "🇪🇸",
  "Ethiopia": "🇪🇹",
  "Finland": "🇫🇮",
  "Fiji": "🇫🇯",
  "Falkland Islands (Malvinas)": "🇫🇰",
  "Micronesia, Federated States Of": "🇫🇲",
  "Faroe Islands": "🇫🇴",
  "France": "🇫🇷",
  "Gabon": "🇬🇦",
  "United Kingdom": "🇬🇧",
  "Grenada": "🇬🇩",
  "Georgia": "🇬🇪",
  "French Guiana": "🇬🇫",
  "Guernsey": "🇬🇬",
  "Ghana": "🇬🇭",
  "Gibraltar": "🇬🇮",
  "Greenland": "🇬🇱",
  "Gambia": "🇬🇲",
  "Guinea": "🇬🇳",
  "Guadeloupe": "🇬🇵",
  "Equatorial Guinea": "🇬🇶",
  "Greece": "🇬🇷",
  "South Georgia And Sandwich Isl.": "🇬🇸",
  "Guatemala": "🇬🇹",
  "Guam": "🇬🇺",
  "Guinea-Bissau": "🇬🇼",
  "Guyana": "🇬🇾",
  "Hong Kong": "🇭🇰",
  "Heard Island & Mcdonald Islands": "🇭🇲",
  "Honduras": "🇭🇳",
  "Croatia": "🇭🇷",
  "Haiti": "🇭🇹",
  "Hungary": "🇭🇺",
  "Indonesia": "🇮🇩",
  "Ireland": "🇮🇪",
  "Israel": "🇮🇱",
  "Isle Of Man": "🇮🇲",
  "India": "🇮🇳",
  "British Indian Ocean Territory": "🇮🇴",
  "Iraq": "🇮🇶",
  "Iran, Islamic Republic Of": "🇮🇷",
  "Iceland": "🇮🇸",
  "Italy": "🇮🇹",
  "Jersey": "🇯🇪",
  "Jamaica": "🇯🇲",
  "Jordan": "🇯🇴",
  "Japan": "🇯🇵",
  "Kenya": "🇰🇪",
  "Kyrgyzstan": "🇰🇬",
  "Cambodia": "🇰🇭",
  "Kiribati": "🇰🇮",
  "Comoros": "🇰🇲",
  "Saint Kitts And Nevis": "🇰🇳",
  "KP": "🇰🇵",
  "Korea": "🇰🇷",
  "Kuwait": "🇰🇼",
  "Cayman Islands": "🇰🇾",
  "Kazakhstan": "🇰🇿",
  "Lao People's Democratic Republic": "🇱🇦",
  "Lebanon": "🇱🇧",
  "Saint Lucia": "🇱🇨",
  "Liechtenstein": "🇱🇮",
  "Sri Lanka": "🇱🇰",
  "Liberia": "🇱🇷",
  "Lesotho": "🇱🇸",
  "Lithuania": "🇱🇹",
  "Luxembourg": "🇱🇺",
  "Latvia": "🇱🇻",
  "Libyan Arab Jamahiriya": "🇱🇾",
  "Morocco": "🇲🇦",
  "Monaco": "🇲🇨",
  "Moldova": "🇲🇩",
  "Montenegro": "🇲🇪",
  "Saint Martin": "🇲🇫",
  "Madagascar": "🇲🇬",
  "Marshall Islands": "🇲🇭",
  "Macedonia": "🇲🇰",
  "Mali": "🇲🇱",
  "Myanmar": "🇲🇲",
  "Mongolia": "🇲🇳",
  "Macao": "🇲🇴",
  "Northern Mariana Islands": "🇲🇵",
  "Martinique": "🇲🇶",
  "Mauritania": "🇲🇷",
  "Montserrat": "🇲🇸",
  "Malta": "🇲🇹",
  "Mauritius": "🇲🇺",
  "Maldives": "🇲🇻",
  "Malawi": "🇲🇼",
  "Mexico": "🇲🇽",
  "Malaysia": "🇲🇾",
  "Mozambique": "🇲🇿",
  "Namibia": "🇳🇦",
  "New Caledonia": "🇳🇨",
  "Niger": "🇳🇪",
  "Norfolk Island": "🇳🇫",
  "Nigeria": "🇳🇬",
  "Nicaragua": "🇳🇮",
  "Netherlands": "🇳🇱",
  "Norway": "🇳🇴",
  "Nepal": "🇳🇵",
  "Nauru": "🇳🇷",
  "Niue": "🇳🇺",
  "New Zealand": "🇳🇿",
  "Oman": "🇴🇲",
  "Panama": "🇵🇦",
  "Peru": "🇵🇪",
  "French Polynesia": "🇵🇫",
  "Papua New Guinea": "🇵🇬",
  "Philippines": "🇵🇭",
  "Pakistan": "🇵🇰",
  "Poland": "🇵🇱",
  "Saint Pierre And Miquelon": "🇵🇲",
  "Pitcairn": "🇵🇳",
  "Puerto Rico": "🇵🇷",
  "Palestinian Territory, Occupied": "🇵🇸",
  "Portugal": "🇵🇹",
  "Palau": "🇵🇼",
  "Paraguay": "🇵🇾",
  "Qatar": "🇶🇦",
  "Reunion": "🇷🇪",
  "Romania": "🇷🇴",
  "Serbia": "🇷🇸",
  "Russian Federation": "🇷🇺",
  "Rwanda": "🇷🇼",
  "Saudi Arabia": "🇸🇦",
  "Solomon Islands": "🇸🇧",
  "Seychelles": "🇸🇨",
  "Sudan": "🇸🇩",
  "Sweden": "🇸🇪",
  "Singapore": "🇸🇬",
  "Saint Helena": "🇸🇭",
  "Slovenia": "🇸🇮",
  "Svalbard And Jan Mayen": "🇸🇯",
  "Slovakia": "🇸🇰",
  "Sierra Leone": "🇸🇱",
  "San Marino": "🇸🇲",
  "Senegal": "🇸🇳",
  "Somalia": "🇸🇴",
  "Suriname": "🇸🇷",
  "SS": "🇸🇸",
  "Sao Tome And Principe": "🇸🇹",
  "El Salvador": "🇸🇻",
  "SX": "🇸🇽",
  "Syrian Arab Republic": "🇸🇾",
  "Swaziland": "🇸🇿",
  "Turks And Caicos Islands": "🇹🇨",
  "Chad": "🇹🇩",
  "French Southern Territories": "🇹🇫",
  "Togo": "🇹🇬",
  "Thailand": "🇹🇭",
  "Tajikistan": "🇹🇯",
  "Tokelau": "🇹🇰",
  "Timor-Leste": "🇹🇱",
  "Turkmenistan": "🇹🇲",
  "Tunisia": "🇹🇳",
  "Tonga": "🇹🇴",
  "Turkey": "🇹🇷",
  "Trinidad And Tobago": "🇹🇹",
  "Tuvalu": "🇹🇻",
  "Taiwan": "🇹🇼",
  "Tanzania": "🇹🇿",
  "Ukraine": "🇺🇦",
  "Uganda": "🇺🇬",
  "United States Outlying Islands": "🇺🇲",
  "United States": "🇺🇸",
  "Uruguay": "🇺🇾",
  "Uzbekistan": "🇺🇿",
  "Holy See (Vatican City State)": "🇻🇦",
  "Saint Vincent And Grenadines": "🇻🇨",
  "Venezuela": "🇻🇪",
  "Virgin Islands, British": "🇻🇬",
  "Virgin Islands, U.S.": "🇻🇮",
  "Viet Nam": "🇻🇳",
  "Vanuatu": "🇻🇺",
  "Wallis And Futuna": "🇼🇫",
  "Samoa": "🇼🇸",
  "Yemen": "🇾🇪",
  "Mayotte": "🇾🇹",
  "South Africa": "🇿🇦",
  "Zambia": "🇿🇲",
  "Zimbabwe": "🇿🇼"
}

const STATUS_TITLES = {
    unfulfilled: "Unfulfilled",
    "awaiting-stock": "Awaiting Stock",
    partial: "Partially Fulfilled",
};

const SHIPPING_TITLES = {
    "same-day": "Same Day",
    "next-day": "Next Day",
    express: "Express",
    standard: "Standard",
    pickup: "Pickup",
    pickup_hq: "Pickup HQ",
    Uber: "Uber",
    uber: "Uber",
    overnight: "Overnight",
};

// Legacy orders page expects double-encoded JSON values for selectedX/filterX params.
const enc = (value) => encodeURIComponent(encodeURIComponent(JSON.stringify(value)));

const buildStatusUrl = (status) =>
    `/orders/?selectedStatus=${enc([status])}&filterStatus=${enc([status])}`;

const buildShippingUrl = (shippingTypes) =>
    `/orders/?selectedShipping=${enc(shippingTypes)}&filterShipping=${enc(shippingTypes)}` +
    `&selectedStatus=${enc(["unfulfilled", "awaiting-stock"])}&filterStatus=${enc(["unfulfilled", "awaiting-stock"])}`;

const buildRegionUrl = (region) =>
    `/orders/?selectedStatus=${enc(["unfulfilled", "awaiting-stock"])}&filterStatus=${enc(["unfulfilled", "awaiting-stock"])}` +
    `&selectedRegion=${enc([region])}&filterRegion=${enc(region)}`;

const buildFlagTypeUrl = (id) =>
    `/orders?selectedFlagType=${enc([id])}&filterFlagType=${enc([id])}`;

const camelToHeadingCase = (str) =>
    str
        .replace(/[-_]/g, " ")
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/^./, (c) => c.toUpperCase());

const Tile = ({ title, count, url, iconClass, fabIcon, color, emoji, ready }) => {
    const inner = (
        <Card className="mini-stats-wid">
            <CardContent className={"p-4 border-solid border-[1av] border-black rounded-md"}>
                <div className="flex items-start space-x-4">
                    <div className="flex-1">
                        <p className="text-slateGray font-weight-medium !mb-4">{title}</p>
                        <h4 className={`mb-0 text-lg ${ready ? "" : "placeholder"}`}>
                            {ready ? count : " "}
                        </h4>
                    </div>
                    {(iconClass || fabIcon || emoji) && (
                        <div
                            className={`mini-stat-icon avatar-sm rounded-circle bg-${color} d-flex align-items-center justify-content-center`}
                        >
                            <span className="" style={emoji ? { fontSize: 32 } : undefined}>
                                {emoji
                                    ? emoji
                                    : fabIcon
                                        ? <i className={`text-white ${fabIcon} font-size-24`}></i>
                                        : <i className={`text-white mdi ${iconClass} font-size-24`}></i>}
                            </span>
                        </div>
                    )}
                </div>
            </CardContent>
        </Card>
    );
    return url ? <Link to={url}>{inner}</Link> : inner;
};

const TileGroup = ({ tiles, ready }) => (
    <div className="relative">
        <div className="absolute inset-y-0 right-0 w-8 bg-gradient-to-l from-gray-50 via-gray-50/50 to-transparent pointer-events-none"></div>
        <Row className="overflow-x-scroll gap-3">
            {tiles.map((tile) => (
                <Col className="min-w-[250px]" key={tile.key}>
                    <Tile {...tile} ready={ready} />
                </Col>
            ))}
        </Row>
    </div>
);

const Dashboard = () => {
    const [data] = useQuery({ url: "/dashboard/details", queryData: {} });
    const [monogramData] = useQuery({ url: "/dashboard/monogram", queryData: {} });

    const dashboard = data && data.data;
    const ready = !!dashboard;

    const completeMonograms = Object.keys(monogramData?.completed || {}).map((key) => ({
        key,
        title: camelToHeadingCase(key),
        count: monogramData?.completed[key],
    }));
    const uncompletedMonograms = [
        {
            title: "Print",
            key: "printJobs",
            count: monogramData ? (monogramData?.stand?.printJobs || 0) + (monogramData?.corp?.printJobs || 0) : 0,
        },
        {
            title: "Embroidery",
            key: "embroideryJobs",
            count: monogramData ? (monogramData?.stand?.embroideryJobs || 0) + (monogramData?.corp?.embroideryJobs || 0) : 0,
        },
        {
            title: "Awaiting Stock",
            key: "awaitingJobs",
            count: monogramData ? (monogramData?.stand?.awaitingJobs || 0) + (monogramData?.corp?.awaitingJobs || 0) : 0,
        },
    ];

    const workflowTiles = dashboard
        ? [
              {
                  key: "monogrammed",
                  title: "Monogrammed",
                  count: dashboard.monogrammed ?? 0,
                  url: '/orders?selectedStatus=%255B%2522unfulfilled%2522%252C%2522awaiting-stock%2522%255D&filterStatus=%255B%2522unfulfilled%2522%252C%2522awaiting-stock%2522%255D&selectedOrder=%255B%2522Has-personalisation%2522%255D&filterOrder=%255B%2522Has-personalisation%2522%255D',
                  iconClass: "mdi-drawing",
                  color: "primary",
              },
              {
                  key: "ready",
                  title: "Ready To Ship",
                  count: dashboard.ready ?? 0,
                  url: '/orders?selectedOrder=%255B%2522ready-to-ship%2522%255D&filterOrder=%255B%2522ready-to-ship%2522%255D&selectedStatus=%255B%2522unfulfilled%2522%255D&filterStatus=%255B%2522unfulfilled%2522%255D',
                  iconClass: "mdi-truck-outline",
                  color: "warning",
              },
          ]
        : [];

    const statusTiles = [
        ...(dashboard?.statusCounts ?? [])
            .filter((s) => s.status !== "unfulfilled")
            .map((s) => ({
                key: `status-${s.status}`,
                title: STATUS_TITLES[s.status] ?? camelToHeadingCase(s.status),
                count: s.count,
                url: buildStatusUrl(s.status),
                iconClass: "mdi-truck-outline",
                color: s.status === "awaiting-stock" ? "secondary" : "primary",
            })),
        ...(dashboard
            ? [{
                key: "status-partial",
                title: STATUS_TITLES.partial,
                count: dashboard.partial ?? 0,
                url: `/orders?selectedOrder=${enc(["partially-fulfilled"])}&filterOrder=${enc(["partially-fulfilled"])}`,
                iconClass: "mdi-progress-check",
                color: "primary",
            }]
            : []),
        ...workflowTiles,
    ].sort((a, b) => b.count - a.count);

    const flagTiles = dashboard
        ? (() => {
              const tiles = [];
              if (dashboard.totalFlagged) {
                  tiles.push({
                      key: "flagged-total",
                      title: "All Flagged",
                      count: dashboard.totalFlagged,
                      url: `/orders?selectedOrder=${enc(["Flagged"])}&filterOrder=${enc(["Flagged"])}`,
                      iconClass: "mdi-flag",
                      color: "danger",
                  });
              }
              let hasUnknown = false;
              for (const ft of dashboard.flagTypeCounts ?? []) {
                  const isUnknown = !ft._id;
                  if (isUnknown) hasUnknown = true;
                  tiles.push({
                      key: `flag-${ft._id ?? "unknown"}`,
                      title: ft.name ?? "Unknown",
                      count: ft.count,
                      url: isUnknown
                          ? `/orders?selectedOrder=${enc(["Flagged"])}&filterOrder=${enc(["Flagged"])}`
                          : buildFlagTypeUrl(ft._id),
                      iconClass: "mdi-flag-outline",
                      color: "danger",
                  });
              }
              if (!hasUnknown) {
                  tiles.push({
                      key: "flag-unknown",
                      title: "Unknown",
                      count: 0,
                      url: `/orders?selectedOrder=${enc(["Flagged"])}&filterOrder=${enc(["Flagged"])}`,
                      iconClass: "mdi-flag-outline",
                      color: "danger",
                  });
              }
              return tiles.sort((a, b) => b.count - a.count);
          })()
        : [];

    const shippingTiles = (dashboard?.shippingCounts ?? [])
        .map((s) => ({
            key: `ship-${s.shipping_type}`,
            title: SHIPPING_TITLES[s.shipping_type] ?? camelToHeadingCase(s.shipping_type),
            count: s.count,
            url: buildShippingUrl([s.shipping_type]),
            iconClass:
                s.shipping_type === "same-day"
                    ? "mdi-clock-fast"
                    : s.shipping_type === "next-day"
                        ? "mdi-truck-fast-outline"
                        : s.shipping_type === "express"
                            ? "mdi-truck-delivery"
                            : s.shipping_type.startsWith("pickup")
                                ? "mdi-inbox-arrow-down"
                                : "mdi-truck-outline",
            fabIcon: s.shipping_type.toLowerCase() === "uber" ? "fab fa-uber" : undefined,
            color: ["same-day", "next-day", "express"].includes(s.shipping_type)
                ? "danger"
                : s.shipping_type.toLowerCase() === "uber"
                    ? "secondary"
                    : s.shipping_type.startsWith("pickup")
                        ? "primary"
                        : "warning",
        }))
        .sort((a, b) => b.count - a.count);

    const regionTiles = (dashboard?.regionCounts ?? [])
        .filter((r) => r.region)
        .map((r) => ({
            key: `region-${r.region}`,
            title: r.region,
            count: r.count,
            url: buildRegionUrl(r.region),
            emoji: countryLookup[r.region] ?? "🌍",
            color: "info",
        }))
        .sort((a, b) => b.count - a.count);

    const user = JSON.parse(localStorage.getItem("authUser"));
    const canSeePending = user.permissions.includes("BookStockDrop") || user.permissions.includes("ViewApprovals");

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="mx-auto px-4 xl:max-w-[85%]">
                    <Breadcrumbs title="Dashboard" breadcrumbItem="Dashboard" />
                    <Row className="flex-wrap">
                        <Col className="xl:w-5/12 pr-3">
                            <WelcomeComp
                                monogramData={monogramData}
                                stateData={{ newOrders: dashboard?.newOrder ?? 0, corp: dashboard?.corp ?? 0 }}
                                dashboard={dashboard}
                            />
                            <Label className="!my-5">Uncompleted Monograms</Label>
                            <div className="relative">
                                <div className="absolute inset-y-0 right-0 w-8 bg-gradient-to-l from-gray-50 via-gray-50/50 to-transparent pointer-events-none"></div>
                                <Row className="overflow-x-scroll gap-3">
                                    {arrayNotNull(uncompletedMonograms) &&
                                        [...uncompletedMonograms]
                                            .sort((a, b) => b.count - a.count)
                                            .map((region, key) => (
                                                <Col className="min-w-[200px]" key={`uncomp_${key}`}>
                                                    <Tile
                                                        title={region.title || "Unknown"}
                                                        count={region.count}
                                                        ready={!!monogramData}
                                                    />
                                                </Col>
                                            ))}
                                </Row>
                            </div>
                            <Label className="!my-5">Completed Monograms</Label>
                            <div className="relative">
                                <div className="absolute inset-y-0 right-0 w-8 bg-gradient-to-l from-gray-50 via-gray-50/50 to-transparent pointer-events-none"></div>
                                <Row className="overflow-x-scroll gap-3">
                                    {arrayNotNull(completeMonograms) &&
                                        [...completeMonograms]
                                            .sort((a, b) => b.count - a.count)
                                            .map((region, key) => (
                                                <Col className="min-w-[200px]" key={`comp_${key}`}>
                                                    <Tile
                                                        title={region.title || "Unknown"}
                                                        count={region.count}
                                                        ready={!!monogramData}
                                                    />
                                                </Col>
                                            ))}
                                </Row>
                            </div>
                        </Col>
                        <Col className="xl:w-7/12 pl-3">
                            {canSeePending && (
                                <>
                                    <Label>PENDING:</Label>
                                    <Row className="flex-row gap-3">
                                        {user.permissions.includes("BookStockDrop") && (
                                            <Col className="sm:w-[49%]">
                                                <Tile
                                                    title="EWE DROPS"
                                                    count={dashboard?.pendingEWE ?? 0}
                                                    url="/stock/replenish"
                                                    ready={ready}
                                                />
                                            </Col>
                                        )}
                                        {user.permissions.includes("ViewApprovals") && (
                                            <Col className="sm:w-6/12">
                                                <Tile
                                                    title="Approvals"
                                                    count={dashboard?.approvals ?? 0}
                                                    url="/approvals"
                                                    ready={ready}
                                                />
                                            </Col>
                                        )}
                                    </Row>
                                </>
                            )}
                            {statusTiles.length > 0 && (
                                <>
                                    <Label className="!my-5">UNFULFILLED ORDERS BY STATUS:</Label>
                                    <TileGroup tiles={statusTiles} ready={ready} />
                                </>
                            )}
                            {flagTiles.length > 0 && (
                                <>
                                    <Label className="!my-5">FLAGGED ORDERS BY TYPE:</Label>
                                    <TileGroup tiles={flagTiles} ready={ready} />
                                </>
                            )}
                            {shippingTiles.length > 0 && (
                                <>
                                    <Label className="!my-5">UNFULFILLED ORDERS BY SHIPPING:</Label>
                                    <TileGroup tiles={shippingTiles} ready={ready} />
                                </>
                            )}
                            {regionTiles.length > 0 && (
                                <>
                                    <Label className="!my-5">UNFULFILLED ORDERS BY REGION:</Label>
                                    <TileGroup tiles={regionTiles} ready={ready} />
                                </>
                            )}
                        </Col>
                    </Row>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Dashboard;
